//import $ from "jquery";
window.$=document.$ = window.jQuery = require("jquery");
window.$body=$("body");
import OneByOne from "./one-by-one/OneByOne"

require("./main.less");
document.addEventListener("DOMContentLoaded", function(event) {
    //do work
    console.log("hello from main.js");

    let test=new OneByOne($("[one-by-one]"),1.7,false)
});